/* ty-versions-links (01.10.2026): כל לחיצה אל iPhone 18 Pro או Pro Max נוחתת בדף «השוואת גרסאות».
 * בקשת יובל: מהתפריט העליון, ממגירת ההמבורגר, ומכרטיסי המוצר בדף הבית ובאוספים.
 *
 * 📌 הקישור משתנה רק ברגע הלחיצה (או הריחוף והפוקוס). ה-HTML נשאר כמו שהוא, ולכן גוגל ממשיך
 *    לראות את דף המוצר הרגיל, ומתג הסניפים מתרגם קישורים כרגיל לפני כן.
 * 📌 שני סוגי יעד:
 *    ① קישור למוצר: הרגיל, eSIM only, יבואן רשמי, ותאומי אילת. רק בתפריטים וברצועת השלישייה (ONLY).
 *    ② קישור לאוסף iphone-18-pro / -max (והתאום באילת): רק בתפריטים, כי שם התפריט מצביע לאוסף.
 * 🔴 «שריון באילת» על כרטיס הוד אינו משתנה: הוא מעביר את הלקוח לסניף אחר במכוון.
 * 📌 הסניף בדף ההשוואה נקבע ממאפיין העגלה, ולכן היעד הוא תמיד ה-handle של ההוד.
 * הכלי: shopify-agent/scripts/apply-versions-compare-2026-10-01.mjs */
(function () {
  if (window.__tyVerLinks) return;
  window.__tyVerLinks = true;

  var PROD = /^(?:\/collections\/[^\/]+)?\/products\/(iphone-18-pro(?:-max)?)(?:-esim-only|-official)?(?:-eilat)?\/?$/;
  var COLL = /^\/collections\/(iphone-18-pro(?:-max)?)(?:-eilat)?\/?$/;
  var SKIP = '.tyc-eilat-btn, .ty-pp-eilat-btn, [data-ty-eilat-buynow], [data-tyv], .breadcrumbs, [data-tyv-skip]';
  var MENU = 'header, .header-wrapper, .mega-menu, .menu-drawer, menu-drawer, header-drawer';

  /* 02.10.2026, הכרעת יובל: ההפניה רק מהתפריטים ומכרטיסי רצועת השלישייה (ty-i18-rail, בדף הבית ובאוסף).
     כרטיסי הרשת באוסף, הבאנרים והחיפוש מובילים לדף המוצר הרגיל. */
  /* ובנוסף הבאנרים בדף הבית (סליידר banners_slideshow), בקשת יובל 02.10.2026 */
  var ONLY = MENU + ', .ty-i18r, .shopify-section[id*="banners_slideshow"]';

  function target(a) {
    if (!a || !a.getAttribute('href') || a.closest(SKIP) || !a.closest(ONLY)) return null;
    var u;
    try { u = new URL(a.href, location.href); } catch (e) { return null; }
    if (u.origin !== location.origin || u.searchParams.has('view')) return null;
    var m = u.pathname.match(PROD);
    if (!m) {
      m = u.pathname.match(COLL);
      if (!m || !a.closest(MENU)) return null;
      u.search = '';
    }
    u.pathname = '/products/' + m[1];
    u.searchParams.set('view', 'versions');
    return u.href;
  }

  function fix(e) {
    var a = e.target && e.target.closest && e.target.closest('a[href]');
    var t = target(a);
    if (t && a.href !== t) a.href = t;
  }

  ['pointerdown', 'mouseover', 'focusin', 'click', 'auxclick'].forEach(function (ev) {
    document.addEventListener(ev, fix, true);
  });
})();
